import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Button from '../assets/Button.png';
import Embroidery from '../assets/Embroidery.png';
import multithread from '../assets/multithread.png';
import Grouppic from '../assets/Grouppic.png';
import sewing from '../assets/sewing.png';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ImageSlider = () => {
  const images = [Button, Embroidery, multithread, Grouppic, sewing];
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Different arc positions for mobile vs desktop
  const arcPositions = isMobile
    ? [
        { x: '-180%', y: '-20%', rotate: -20 }, // bottom-left
        { x: '-90%', y: '-40%', rotate: -10 }, // top-left
        { x: '0%', y: '-50%', rotate: 0 }, // center
        { x: '90%', y: '-40%', rotate: 10 }, // top-right
        { x: '180%', y: '-20%', rotate: 20 }, // bottom-right
      ]
    : [
        { x: '-240%', y: '20%', rotate: -20 }, // bottom-left
        { x: '-130%', y: '-4%', rotate: -10 }, // top-left
        { x: '0%', y: '-12%', rotate: 0 }, // center
        { x: '130%', y: '-4%', rotate: 10 }, // top-right
        { x: '240%', y: '20%', rotate: 20 }, // bottom-right
      ];

  // Different image sizes for mobile vs desktop
  const imageSize = isMobile
    ? { width: '310px', height: '440px' }
    : { width: '310px', height: '440px' };

  const containerHeight = isMobile ? 'h-[150px]' : 'h-[300px]';

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleBack = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  useEffect(() => {
    const interval = setInterval(handleNext, 6000);
    return () => clearInterval(interval);
  }, []);

  const rotatedImages = [
    ...images.slice(currentIndex),
    ...images.slice(0, currentIndex),
  ];

  return (
    <div className={`relative flex items-center justify-center ${containerHeight} w-full`}>
      <div className="relative flex justify-center items-center w-full h-full">
        {rotatedImages.map((image, i) => {
          const position = arcPositions[i];
          return (
            <motion.img
              key={image} // use image src as unique key
              src={image}
              alt={`Image ${i + 1}`}
              className="absolute rounded-t-[300px]"
              animate={{
                x: position.x,
                y: position.y,
                rotate: position.rotate,
                opacity: 1,
                scale: 1,
              }}
              transition={{
                duration: 0.8,
                ease: 'easeInOut',
              }}
              style={imageSize}
            />
          );
        })}
      </div>

      {/* Back Button */}
      {!isMobile && (
        <button
          className={`absolute left-0 text-white bg-customRed rounded-full p-2 z-10 flex items-center justify-center`}
          onClick={handleBack}
        >
          <ChevronLeft size={24} />
        </button>
      )}

      {/* Next Button */}
      {!isMobile && (
        <button
          className={`absolute right-0 text-white bg-customRed rounded-full p-2 z-10 flex items-center justify-center`}
          onClick={handleNext}
        >
          <ChevronRight size={24} />
        </button>
      )}
    </div>
  );
};

export default ImageSlider;
